import React from 'react'
import { intl } from 'lang/intl'

import { TtButton, TtIcon, TtTooltip } from '@23/ui-react'

import { toggleMidiControls, useMidiEnabled } from '../../../../midi/blocs/midi'

const Midi = () => {
  const enabled = useMidiEnabled()
  return (
    <TtTooltip
      content={intl.formatMessage({ defaultMessage: 'Enable MIDI controls' })}
      placement="left"
      distance={16}
    >
      <TtButton
        circle
        color={enabled ? 'primary' : 'secondary'}
        onClick={toggleMidiControls}
      >
        <TtIcon name="automation" library="one" />
      </TtButton>
    </TtTooltip>
  )
}

export { Midi }
